import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ElectronicSignature\DeleteElectronicSignatureController::__invoke
* @see app/Http/Controllers/ElectronicSignature/DeleteElectronicSignatureController.php
* @route '/api/electronic-signature/{electronicSignature}'
*/
const DeleteElectronicSignatureController = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteElectronicSignatureController.url(args, options),
    method: 'delete',
})

DeleteElectronicSignatureController.definition = {
    methods: ["delete"],
    url: '/api/electronic-signature/{electronicSignature}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ElectronicSignature\DeleteElectronicSignatureController::__invoke
* @see app/Http/Controllers/ElectronicSignature/DeleteElectronicSignatureController.php
* @route '/api/electronic-signature/{electronicSignature}'
*/
DeleteElectronicSignatureController.url = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { electronicSignature: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { electronicSignature: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            electronicSignature: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        electronicSignature: typeof args.electronicSignature === 'object'
        ? args.electronicSignature.id
        : args.electronicSignature,
    }

    return DeleteElectronicSignatureController.definition.url
            .replace('{electronicSignature}', parsedArgs.electronicSignature.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ElectronicSignature\DeleteElectronicSignatureController::__invoke
* @see app/Http/Controllers/ElectronicSignature/DeleteElectronicSignatureController.php
* @route '/api/electronic-signature/{electronicSignature}'
*/
DeleteElectronicSignatureController.delete = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteElectronicSignatureController.url(args, options),
    method: 'delete',
})

export default DeleteElectronicSignatureController